import React, { useEffect, useState } from "react"
import { Row, Col, Card, Form } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { URLS } from "../../Url"
import axios from "axios"

const PrivacyPolicy = () => {
  const [text, setText] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  // Get auth token
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const TokenData = TokenJson?.token

  useEffect(() => {
    GetPolicy()
  }, [])

  const GetPolicy = async () => {
    try {
      if (!TokenData) {
        throw new Error("Authentication token not found")
      }

      const response = await axios.post(
        URLS.GetPolicy,
        {},
        {
          headers: { Authorization: `Bearer ${TokenData}` },
        }
      )

      setText(response.data.policy.privacyPolicy)
    } catch (err) {
      console.error("Error fetching privacy policy:", err)
      setError(err.message || "Failed to load privacy policy")
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="Privacy Policy" />

          <Row className="justify-content-center">
            <Col xl="12">
              <Card className="p-4 shadow-sm">
                <Form onSubmit={e => e.preventDefault()}>
                  <Col md="12">
                    <div className="text-center mb-4">
                      <h2 className="text-primary fw-bold">Privacy Policy</h2>
                      <p className="text-muted">
                        Last updated: {new Date().toLocaleDateString()}
                      </p>
                    </div>

                    <hr className="my-4" />

                    {loading ? (
                      <div className="text-center py-5">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Loading privacy policy...</p>
                      </div>
                    ) : error ? (
                      <div className="alert alert-danger text-center">
                        {error}
                      </div>
                    ) : (
                      <div
                        className="policy-content p-3 rounded"
                        style={{
                          lineHeight: "1.8",
                          fontSize: "1.05rem",
                        }}
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: text }}
                          style={{
                            fontFamily:
                              "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                            color: "#333",
                          }}
                        />
                      </div>
                    )}
                  </Col>
                </Form>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default PrivacyPolicy
